import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const ManagedITServices = () => {
  return (
    <>
      <SEO 
        title="Managed IT Services - Abacies Logiciels"
        description="Comprehensive managed IT services including infrastructure management, cloud operations, 24/7 monitoring, help desk support, and proactive maintenance to keep your systems running smoothly."
        keywords="managed IT services, IT support, infrastructure management, cloud management, IT monitoring, help desk, IT operations"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Managed IT Services
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Managed IT Services page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Managed IT Services. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ManagedITServices;
